import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getRequestHeaders } from '../utils/getHeaderData';
import { API_URL, endpointTags } from '../constants';
export const baseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    credentials: 'include',
  }),
  endpoints: () => ({}),
  tagTypes: endpointTags,
});

export const { useLazyFunctionNameQuery } = baseApi;

export function createConsiliApi(functionName, queryURL, method, providesTags) {
  return baseApi.injectEndpoints({
    endpoints: (builder) => ({
      [functionName]: builder.query({
        query: (credentials) => ({
          url: queryURL,
          method: method,
          headers: getRequestHeaders(),
          body: credentials,
        }),
        providesTags: providesTags,
      }),
    }),
    overrideExisting: false,
  });
}

export function addConsiliApi(functionName, queryURL, method, invalidatedTags) {
  return baseApi.injectEndpoints({
    endpoints: (builder) => ({
      [functionName]: builder.mutation({
        query: (data) => ({
          url: queryURL(data),
          method: method,
          headers: getRequestHeaders(),
          body: data,
        }),
        invalidatesTags: invalidatedTags,
      }),
    }),
    overrideExisting: false,
  });
}

export function injectLogoutEndpoint(
  functionName,
  queryURL,
  method,
  invalidatedTags
) {
  return baseApi.injectEndpoints({
    endpoints: (builder) => ({
      [functionName]: builder.query({
        query: (data) => ({
          url: queryURL,
          method: method,
          headers: getRequestHeaders(),
          body: data,
        }),
        invalidatesTags: invalidatedTags,
      }),
    }),
    overrideExisting: false,
  });
}
